'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dRestricted$002dDomains$0024 from "./presto.-List-Restricted-Domains$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002481 from "./presto.-Presto-Router$$anon$81.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$80() {
  this.bnM = null;
  this.bnE = null;
  this.bnF = false;
  this.bnN = null;
  this.bnO = false;
  this.bnR = null;
  this.bnK = null;
  this.bnL = false;
  this.bnG = null;
  this.bnH = false;
  this.bnI = null;
  this.bnJ = false;
  this.bnP = false;
  this.bnQ = false;
  this.bnM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bnR = "ListRestrictedDomains";
}
export { $c_Lpresto_PrestoRouter$$anon$80 as $c_Lpresto_PrestoRouter$$anon$80 };
$p = $c_Lpresto_PrestoRouter$$anon$80.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$80;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$80() {
}
export { $h_Lpresto_PrestoRouter$$anon$80 as $h_Lpresto_PrestoRouter$$anon$80 };
$h_Lpresto_PrestoRouter$$anon$80.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bnM;
});
$p.L = (function() {
  if ((!this.bnF)) {
    this.bnE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnF = true;
  }
  return this.bnE;
});
$p.O = (function() {
  if ((!this.bnO)) {
    this.bnN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bnO = true;
  }
  return this.bnN;
});
$p.E = (function() {
  return this.bnR;
});
$p.t = (function() {
  if ((!this.bnL)) {
    this.bnK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnL = true;
  }
  return this.bnK;
});
$p.M = (function() {
  if ((!this.bnH)) {
    this.bnG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnH = true;
  }
  return this.bnG;
});
$p.Q = (function() {
  if ((!this.bnJ)) {
    this.bnI = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002481.$c_Lpresto_PrestoRouter$$anon$81();
    this.bnJ = true;
  }
  return this.bnI;
});
$p.w = (function() {
  if ((!this.bnQ)) {
    this.bnP = false;
    this.bnQ = true;
  }
  return this.bnP;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee535) => ((p) => \u03b4scrutinee535))($j_presto$002e$002dList$002dRestricted$002dDomains$0024.$m_Lpresto_ListRestrictedDomains$())));
});
var $d_Lpresto_PrestoRouter$$anon$80 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$80, "presto.PrestoRouter$$anon$80", ({
  OO: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$80 as $d_Lpresto_PrestoRouter$$anon$80 };
//# sourceMappingURL=presto.-Presto-Router$$anon$80.js.map
